import React from 'react';

const About = () => {
  return (
    <section id="about" style={{
      padding: '80px 5%',
      backgroundColor: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }}>
      <h2 style={{
        fontSize: '2.5rem',
        marginBottom: '30px',
        color: '#1a73e8'
      }}>About Us</h2>
      
      <p style={{
        maxWidth: '900px',
        fontSize: '1.1rem',
        lineHeight: 1.7,
        color: '#555'
      }}>
        Peerwatt was founded to be different, to be a partner that offers deep energy system understanding without hidden interests or commercial bias.
        As experienced energy modelers and market specialists, we saw a growing need for independent expertise:
        the kind that brings rigorous analysis, honest answers, and a clear understanding of both market forces and technical constraints.
        <br /><br />
        We work at the intersection of modeling and strategy, from PLEXOS simulations and battery optimization to pan-European hydrogen pathways.
        Our mission is simple: <strong>to deliver actionable, unbiased insights that support resilient, future-ready energy decisions.</strong>
      </p>
    </section>
  );
};

export default About;
